<p-select
  [options]="languages"
  [ngModel]="currentLanguage"
  (ngModelChange)="onLanguageChange($event)"
  optionLabel="name"
  optionValue="code"
  [showClear]="false"
  size="small">
  
  <ng-template let-language pTemplate="selectedItem">
      <span class="text-white">{{ language.name }}</span>
  </ng-template>
  
  <ng-template let-language pTemplate="item">
      <span>{{ language.name }}</span>
  </ng-template>
</p-select>
